import '../styles/Primitives.scss';

export default function CircularProgress({ className = '', color, size = 40, style, thickness = 2, ...props }) {
  return <span aria-label="Chargement" role="progressbar" className={`ui-circular-progress ${className}`.trim()} style={{ width: size, height: size, borderWidth: thickness, ...style }} {...props} />;
}
